import { h, Component } from "preact"
import { gtagDatalayer, isNequiThirdPartyCheckout } from "../../utils/helpers"
import MerchantInfoDrawer from "../MerchantInfoDrawer/MerchantInfoDrawer"
import i18next from "../../i18n/i18n"
import PropTypes from "prop-types"
import darkCircle from "../../assets/icons/circle-solid-marked.svg"
import downArrow from "../../assets/icons/down-arrow.svg"

import style from "./PricePanel.sass"

export default class PricePanel extends Component {
  constructor() {
    super()
    this.state = {
      isHelpOpen: false,
      merchantLogoError: false,
      productImageError: false,
      showMore: false,
    }
  }

  toggleHelp = () => {
    this.setState((prevState) => ({
      isHelpOpen: !prevState.isHelpOpen,
    }))
    gtagDatalayer({
      event: "necesita_ayuda",
      category: "UI :: Dashboard",
      action: "Necesitas ayuda?",
    })
  }

  componentDidUpdate(prevProps) {
    const prevPaymentLink = prevProps.store?.$state?.paymentLink
    const currentPaymentLink = this.props.store?.$state?.paymentLink

    const prevMerchantLogo = prevProps.store?.$state?.merchant?.logoUrl || ""
    const currentMerchantLogo = this.props.store?.$state?.merchant?.logoUrl || ""

    const prevProductImage = prevPaymentLink?.imageUrl || ""
    const currentProductImage = currentPaymentLink?.imageUrl || ""

    if (
      prevMerchantLogo !== currentMerchantLogo ||
      prevProductImage !== currentProductImage
    ) {
      this.setState({
        merchantLogoError: false,
        productImageError: false,
      })
    }
  }

  handleShowInfo = () => {
    this.setState((prevState) => ({
      showMore: !prevState.showMore,
    }))
  }

  render() {
    const { isHelpOpen, merchantLogoError, productImageError, showMore } = this.state
    const { $state } = this.props.store
    const { PCOData, thirdPartyCheckout } = $state
    const paymentLink = $state.paymentLink || {}
    const merchant = $state.merchant || {}    

    const {
      name: productName = null,
      description = null,
      imageUrl = null,
    } = paymentLink

    const { logoUrl: merchantLogo = null, name: merchantName } = merchant

    const resolvedMerchantName =
      typeof merchantName === "string" &&
      merchantName !== "Datáfono Virtual" &&
      merchantName !== "Terminal Virtual"
        ? merchantName
        : i18next.t("paymentLinkInfo.name")

    const hasProductName = typeof productName === "string" && productName.trim() !== ""
    const hasDescription = typeof description === "string" && description.trim() !== ""
    const hasMerchantLogo = Boolean(merchantLogo) && !merchantLogoError
    const hasProductImage = Boolean(imageUrl) && !productImageError

    const merchantPhone = paymentLink?.merchantPhone ?? ""
    const merchantEmail = paymentLink?.merchantEmail ?? ""
    const merchantSince = paymentLink?.merchantSince ?? ""
    const processedPaymentsText = i18next.t("paymentLinkInfo.processedPayments")

    return (
      <div className={style.pricePanel}>
        <div className={style.paymentDetails}>
          <div className={style.nameWrapper}>
            {PCOData?.showHeadertext ? (
              <div className={style.itemName}>
                <div className={style.merchantLabel}>{i18next.t("paymentLinkInfo.payTo")}</div>
                <div className={style.merchantName}>{PCOData.headerText}</div>
              </div>
            ) : (
              <div className={style.itemName}>
                <div className={style.topVisualBlock}>
                  {hasMerchantLogo && (
                    <div className={`${style.merchantLogoWrapper} ${style.isRealLogo}`}>
                      <img
                        src={merchantLogo}
                        alt="merchant-logo"
                        className={`${style.merchantLogoImage} ${style.realLogoImage}`}
                        onError={() => this.setState({ merchantLogoError: true })}
                      />
                    </div>
                  )}
                </div>

                <div className={style.merchantLabel}>{i18next.t("paymentLinkInfo.payTo")}</div>
                <div className={style.merchantName} title={resolvedMerchantName}>
                  {resolvedMerchantName}
                </div>

                <button
                  className={`${style.infoPill} ${isNequiThirdPartyCheckout(thirdPartyCheckout) ? style["infoPill-nequi"] : ""}`}
                  onClick={this.toggleHelp}
                  type="button"
                >
                  <img src={darkCircle} alt="" aria-hidden="true" className={style.infoIconImage} />
                  <span className={style.infoPillText}>
                    {i18next.t("paymentLinkInfo.merchantInformation")}
                  </span>
                  <img src={downArrow} alt="" aria-hidden="true" className={style.infoChevronImage} />
                </button>

                <div className={`${style.expandableContent} ${showMore ? style.expanded : ""}`}>
                  {hasProductImage && (
                    <div className={style.productImageWrapper}>
                      <img
                        src={imageUrl}
                        alt="product"
                        className={style.productImage}
                        onError={() => this.setState({ productImageError: true })}
                      />
                    </div>
                  )}
                  {hasProductName && (
                    <span className={style.productName} title={productName}>
                      {productName}
                    </span>
                  )}
                  {hasDescription && (
                    <span className={style.productDescription} title={description}>
                      {description}
                    </span>
                  )}
                </div>

                <button
                  type="button"
                  className={style.showMore}
                  onClick={this.handleShowInfo}
                >
                  {i18next.t(`paymentLinkInfo.${showMore ? "showLess" : "showMore"}`)}
                </button>
              </div>
            )}
          </div>

          <MerchantInfoDrawer
            isOpen={isHelpOpen}
            onClose={this.toggleHelp}
            merchantName={resolvedMerchantName}
            merchantLogo={merchantLogo}
            productImage={imageUrl}
            merchantPhone={merchantPhone}
            merchantEmail={merchantEmail}
            merchantSince={merchantSince}
            processedPaymentsText={processedPaymentsText}
            store={this.props.store}
          />
        </div>
      </div>
    )
  }
}

PricePanel.propTypes = {
  store: PropTypes.object.isRequired,
}
